<template>
  <v-container fluid class="is-flex-column presentation-page">
    <v-flex xs12 class="is-flex-column align-center" :class="view.xsOnly ? 'px-4 mt-2' : ' mt-4 px40'">
      <v-avatar :size="avatarSize" color="grey lighten-4">
        <img src="../../public/portrait.jpg" alt="photo">
      </v-avatar>
      <h2 class="mt-3 mb-2">Michel COUPERT</h2>
      <span class="subheading text-xs-center accent--text font-weight-medium">
        Juriste expert en Droit social<br />
        Droit du travail - Droit de la sécurité sociale - Médiateur -
        Précontentieux et contentieux social
      </span>
    </v-flex>

    <v-layout row wrap :class="view.xsOnly ? 'pb-4 pt-2' : view.smOnly ? 'px-1 pb-5' : 'px40 pb-5'">
      <v-flex xs12 sm12 md6 :class="view.xsOnly ? 'px-4 pt-3' : 'px40 pt-5'">
        <h3 class="text-uppercase">Historique</h3>
        <balance-border :color="'secondary'" />
        <p class="mb-2">Juriste spécialisé en droit social depuis plus de trente ans, 
          ayant évolué dans les organisations professionnelles patronales, 
            interprofessionnelles, métallurgie, Fédération des fabricants de tuiles et briques,
             et ayant exercé dans plusieurs régions de France.
        </p>
        <p>J'ai une parfaite expérience du quotidien des entreprises, PME et TPE.</p>
      </v-flex>

      <v-flex xs12 sm12 md6 class="is-flex-column" :class="view.xsOnly ? 'px-4 pt-3' : 'px40 pt-5'">
        <h3 class="text-uppercase">Profil actuel</h3>
        <balance-border :color="'primary'" />
        <p class="mb-2">MC CONSULTANT, c'est un juriste qui met son expertise en droit social, 
          ainsi que ses compétences en matière de médiation professionnelle et de formation, 
            au service des entreprises de tout secteur, de toute taille.
        </p>
        <p>La plus-value étant de faire que du sur-mesure, avec une parfaite connaissance du terrain
            et la confiance de ses clients.
        </p>
      </v-flex>
    </v-layout>

    <v-layout row wrap class="primary white--text" :class="view.xsOnly ? 'py-4' : view.smOnly ? 'px-1 py-5' : 'px40 py-5'">

      <v-flex xs12 sm12 md6 :class="view.xsOnly ? 'px-4 mb-3' : 'px40 mb-4'">
        <div class="is-flex align-center">
          <img src="@/assets/user-line.svg" class="icon-lg" />
          <h3 class="text-uppercase ml-3">Nos valeurs</h3>
        </div>
        <p class="my-2">Réactivité, Disponibilité, Simplicité, Précision et Détermination.</p>
      </v-flex>

      <v-flex xs12 sm12 md6 class="is-flex-column" :class="view.xsOnly ? 'px-4 mb-3' : 'px40 mb-4'">
        <div class="is-flex align-center">
          <img src="@/assets/flame-line.svg" class="icon-lg" />
          <h3 class="text-uppercase ml-3">Notre volonté</h3>
        </div>
        <p class="my-2">Fournir un accompagnement juridique au plus près de vos besoins.</p>
      </v-flex>

      <v-flex xs12 sm12 md6 :class="view.xsOnly ? 'px-4 mb-3' : 'px40 mb-4'">
        <div class="is-flex align-center">
          <img src="@/assets/list-line.svg" class="icon-lg" />
          <h3 class="text-uppercase ml-3">Notre démarche</h3>
        </div>
        <p class="my-2">Faire appel au bon sens, proscrire le verbiage juridique, 
          adopter une démarche pédagogique et respecter vos objectifs.
        </p>
        <p>Dans le cadre d’une négociation raisonnée, nous privilégions la médiation, 
          une voie alternative de règlement des litiges particulièrement bien adaptée aux TPE/PME.</p>
      </v-flex>

      <v-flex xs12 sm12 md6 class="is-flex-column" :class="view.xsOnly ? 'px-4 mb-3' : 'px40'">
        <div class="is-flex align-center">
          <img src="@/assets/bullseye-line.svg" class="icon-lg" />
          <h3 class="text-uppercase ml-3">Notre objectif</h3>
        </div>
        <p class="my-2">Instaurer avec vous une relation de confiance, 
          de proximité et construite dans la durée.
        </p>
        <p>Encadrer et sécuriser la gestion des relations de travail dans votre entreprise : 
            avec une offre de services adossée à des pistes d’amélioration, basée sur nos innovations
              pratiques, nos conseils techniques et des retours d’expérience.
        </p>
      </v-flex>

      <v-flex xs12 class="white--text quote font-weight-medium white--text text-xs-center my-3"
        :class="view.xsOnly ? 'px-4' : 'px-5 pt-5'">
        <b>“ Ensemble, faisons de votre capital humain un véritable moteur et levier de développement. ”</b>
      </v-flex>

    </v-layout>

    

  </v-container>
</template>

<script>
import BalanceBorder from '@/components/BalanceBorder.vue'

export default {
  name: 'presentation',
  components: {
    BalanceBorder
  },
  computed: {
    avatarSize () {
      if (this.$vuetify.breakpoint.xsOnly) return 100
      if (this.$vuetify.breakpoint.smOnly) return 150
      if (this.$vuetify.breakpoint.mdAndUp) return 180
    },
    view () {
      return {
        xsOnly: this.$vuetify.breakpoint.xsOnly,
        smOnly: this.$vuetify.breakpoint.smOnly,
        smAndDown: this.$vuetify.breakpoint.smAndDown,
      }
    }
  },
  created () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="stylus">
.icon-lg
  height: 48px

.presentation-page .quote
  font-size: 20px

// Style for extra small devices
.xsOnly .presentation-page h2
  font-size: 1.4rem

.xsOnly .presentation-page h3
  font-size: 1rem

.xsOnly .presentation-page p
  font-size: 13px

.xsOnly .presentation-page span 
  font-size: 0.9rem !important

.xsOnly .presentation-page .quote
  font-size: 1rem

.xsOnly .presentation-page .icon-lg
  height: 32px
</style>

